import { memo } from "react";

export interface StandMotorDataProps {
  label: string;
  value: string;
}

const StandMotorData = ({ label, value }: StandMotorDataProps) => {
  return (
    <div>
      <div className="text-ib-main text-ib-gray-main">{label}</div>
      <div className="font-ib-bold text-[16px] leading-[24px] text-ib-black">
        {value}
      </div>
    </div>
  );
};

export default memo(StandMotorData);
